import { Fragment, useEffect, useState, useContext } from "react";

import { Link, useNavigate } from "react-router-dom";
import { Modal, Spinner, Button, ButtonGroup, Form } from "react-bootstrap";
import axios from "axios";
import { useUserState, UserContext } from "../../../Contexts/UserContext";

import PlusSvg from "../../../assets/images/plus.svg";
import EditImg from "../../../assets/images/Edit.png";
import TrashImg from "../../../assets/images/Trash.png";
import FurnitureImage from "../../../assets/images/plammulti.png";
import "./index.css";
import MonthsAccordion from "./monthsAccordion";

const MyFurnitureStoreTest = () => {
  const { user } = useUserState();
  // const navigate = useNavigate();
  const { setFurEditData } = useContext(UserContext);
  const [categoryId, setCategoryId] = useState("1");
  const [furnitureData, setFurnitureData] = useState([]);
  const [furPlan, setFurPlan] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [delFurId, setDelFurId] = useState("");
  const [delLoader, setDelLoader] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isActive, setIsActive] = useState();

  const [showPackageModal, setShowPackageModal] = useState(false);
  const [editPackageId, setEditPackageId] = useState(null);
  const [packageName, setPackageName] = useState("");
  const [inputError, setInputError] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [delPkgId, setDelPkgId] = useState(null);

  const getFurnitures = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      setIsLoader(true);
      try {
        let res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture/get-by-user/${categoryId}`,
          { headers: headersFormData }
        );
        setFurnitureData(res?.data?.data);
        setIsLoader(false);
      } catch (err) {
        setIsLoader(false);
        return console.log(err);
      }
    }
  };

  const handleDeleteFurniture = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      setDelLoader(true);
      try {
        let res = await axios.delete(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture/delete/${delFurId}`,
          { headers: headersFormData }
        );
        if (res) {
          setDelLoader(false);
          getFurnitures();
          setDeleteModal(false);
        }
      } catch (err) {
        console.log(err);
        setDelLoader(false);
      }
    }
  };

  const getCategoriesData = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setIsLoader(true);
    try {
      let res = await axios.get(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/furniture-category/get-category-list-by-company`,
        { headers: headersFormData }
      );
      setCategoryId(res?.data?.data[0]?.id);
      setIsActive(res?.data?.data[0]?.id);
      setFurPlan(res?.data?.data);
      setIsLoader(false);
    } catch (err) {
      console.log("get_category", err);
      setIsLoader(false);
    }
  };

  useEffect(() => {
    getCategoriesData();
  }, [user?.token]);

  useEffect(() => {
    getFurnitures();
    // eslint-disable-next-line
  }, [user?.token, categoryId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    // eslint-disable-next-line
  }, []);
  // const handleNewAddFurniture = (id) => {
  //   setFurEditData("")
  //   navigate("/user_dash/furniture_company/add_new_furniture", {
  //     state: { categoryId: id },
  //   });
  // }

  const handleAddPackage = () => {
    setPackageName("");
    setEditPackageId(null);
    setInputError(false);
    setShowPackageModal(true);
  };

  const handleEditPackage = (pkg) => {
    setPackageName(pkg?.name);
    setEditPackageId(pkg?.id);
    setInputError(false);
    setShowPackageModal(true);
  };

  const handleSavePackage = async () => {
    if (!packageName.trim()) {
      setInputError(true);
      return;
    }
    setInputError(false);
    setModalLoader(true);

    const headers = { Authorization: user.token };
    const payload = { name: packageName };

    try {
      if (editPackageId) {
        await axios.put(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/furniture-category/update/${editPackageId}`,
          payload,
          { headers }
        );
      } else {
        await axios.post(
          `${import.meta.env.VITE_APP_BASE_URL}/api/furniture-category/create`,
          payload,
          { headers }
        );
      }
      setShowPackageModal(false);
      setPackageName("");
      setEditPackageId(null);
      getCategoriesData(); // Refresh tabs
    } catch (err) {
      console.log("save_package", err);
    } finally {
      setModalLoader(false);
    }
  };

  const handleDeletePackage = async () => {
    if (!delPkgId) return;
    setDelLoader(true);
    try {
      await axios.delete(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/furniture-category/delete/${delPkgId}`,
        { headers: { Authorization: user.token } }
      );
      setDelPkgId(null);
      getCategoriesData(); // Refresh tabs
    } catch (err) {
      console.log("delete_package", err);
    } finally {
      setDelLoader(false);
    }
  };

  return (
    <Fragment>
      <div className="main-box">
        <div className="content-header">
          <h3>My Furniture Store</h3>
          {/* <button
            type="button"
            className="druyp-btn"
            onClick={() => handleNewAddFurniture(categoryId)}
          >
            <img src={PlusSvg} alt="Edit" /> Add New Furniture
          </button> */}
        </div>

        <div className="myfurnit_store_main">
          <div className="d-flex justify-content-between">
            {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
            {furPlan &&
              furPlan?.map((ele) => {
                return (
                  <li className="nav-item" role="presentation" key={ele?.id}>
                    <button
                      className={`nav-link ${isActive === ele?.id ? "active" : ""}`}
                      type="button"
                      onClick={() => {
                        setCategoryId(ele?.id);
                        setIsActive(ele?.id);
                      }}
                    >
                      {ele?.name}
                    </button>
                  </li>
                );
              })}
          </ul> */}

            <ul className="nav nav-tabs" id="myTab" role="tablist">
              {furPlan.map((pkg) => (
                <li className="nav-item" key={pkg.id}>
                  <button
                    className={`nav-link package-tab ${
                      isActive === pkg.id ? "active" : ""
                    }`}
                    type="button"
                    onClick={() => setIsActive(pkg.id)}
                  >
                    <span className="pkg-name">{pkg.name}</span>

                    <div className="action-icons">
                      <img
                        src={EditImg}
                        alt="edit"
                        className="icon-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditPackage(pkg);
                        }}
                      />
                      <img
                        src={TrashImg}
                        alt="delete"
                        className="icon-btn "
                        onClick={(e) => {
                          e.stopPropagation();
                          setDelPkgId(pkg.id);
                        }}
                      />
                    </div>
                  </button>
                </li>
              ))}
            </ul>

            {furPlan.length < 3 && (
              <button
                type="button"
                className="druyp-btn"
                onClick={handleAddPackage}
              >
                <img src={PlusSvg} alt="Add" /> Add New Package Name
              </button>
            )}
          </div>
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active" role="tabpanel">
              <ul className="mystore_cont">
                {isLoader ? (
                  <div className="eye-loader-frame m-5 p-5">
                    <div className="eye-loader-spinner"></div>
                  </div>
                ) : (
                  <>
                    {/* {furnitureData?.length > 0 ? (
                      furnitureData?.map((ele) => {
                        return (
                          <li className="mystore_cont_inner" key={ele?.id}>
                            <div className="my_store_img">
                              <img
                                src={`${import.meta.env.VITE_APP_BASE_URL}${
                                  ele?.furniture_images[0]?.imageUrl
                                }`}
                                alt="furniture"
                                onError={(e) => {
                                  e.target.src = FurnitureImage;
                                }}
                              />
                              <div
                                className="delux_edit_icon"
                                onClick={() => {
                                  setFurEditData(ele);
                                  navigate(
                                    "/user_dash/furniture_company/add_new_furniture"
                                  );
                                }}
                              >
                                <img src={EditImg} alt="edit" />
                              </div>
                              <div
                                className="trash_icon"
                                onClick={() => {
                                  setDelFurId(ele?.id);
                                  setDeleteModal(true);
                                }}
                              >
                                <img src={TrashImg} alt="trash" />
                              </div>
                            </div>
                            <h4>{ele?.name}</h4>
                          </li>
                        );
                      })
                    ) : (
                      <p>There is currently no item</p>
                    )} */}

                    <MonthsAccordion
                      planActive={isActive}
                      categoryName={
                        furPlan.find((ele) => ele.id === isActive)?.name
                      }
                      categoryId={
                        furPlan.find((ele) => ele.id === isActive)?.id
                      }
                    />
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Add/Edit Package Modal */}
      <Modal
        show={showPackageModal}
        onHide={() => setShowPackageModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editPackageId ? "Edit Package Name" : "Add Package Name"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Package Name</Form.Label>
            <Form.Select
              value={packageName}
              onChange={(e) => setPackageName(e.target.value)}
            >
              <option value="">Select a package</option>
              <option value="Basic Plan">Basic Plan</option>
              <option value="Premium Plan">Premium Plan</option>
              <option value="Deluxe Plan">Deluxe Plan</option>
              <option value="Tier 1">Tier 1</option>
              <option value="Tier 2">Tier 2</option>
              <option value="Tier 3">Tier 3</option>
            </Form.Select>
            {inputError && !packageName && (
              <div className="text-danger mt-2">Package name is required</div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPackageModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={modalLoader}
            onClick={handleSavePackage}
          >
            {editPackageId ? "Update" : "Save"}{" "}
            {modalLoader && <Spinner animation="border" size="sm" />}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={!!delPkgId}
        onHide={() => setDelPkgId(null)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Package</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this package?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDelPkgId(null)}>
            No
          </Button>
          <Button
            variant="primary"
            disabled={delLoader}
            onClick={handleDeletePackage}
          >
            Yes {delLoader && <Spinner animation="border" size="sm" />}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Furniture</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this furniture!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            No
          </Button>
          <Button
            variant="primary"
            disabled={delLoader}
            onClick={() => handleDeleteFurniture()}
          >
            Yes {delLoader && <Spinner />}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default MyFurnitureStoreTest;
